
export class GetHasSoldTicketsByEventIdRequestDto {
  eventId: string;
  withFreeTickets?: boolean;
}
